var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateServiceTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 278,
    viewBox: "0 0 123 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2069 38.4556C14.2069 38.4556 15.6299 35.8647 15.4834 33.7962C15.337 31.7276 16.6344 28.6561 15.2533 28.8859C13.8721 29.1158 13.5791 28.9277 13.2233 31.4142C12.8257 33.9215 9.45654 43.1151 14.2069 38.4556Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8579 275.841C75.8355 275.694 73.2197 275.109 71.8804 274.566C71.8804 275.068 71.8804 275.569 71.9013 276.091C71.9222 276.655 72.3408 277.094 72.843 277.094L100.445 276.906C101.324 276.906 101.847 275.882 101.45 275.067C97.8503 275.402 88.6426 276.07 80.8579 275.841Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0731 265.289C73.7009 263.053 75.7726 261.528 78.1164 261.59L80.4184 261.653C92.6814 264.599 98.8966 271.369 101.345 274.775C101.387 274.838 101.429 274.921 101.45 274.984C97.8293 275.276 88.6216 275.945 80.8369 275.736C75.8145 275.59 73.1987 275.005 71.8594 274.461C71.8803 270.533 72.4453 267.462 73.0731 265.289Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.289 253.755L82.3638 263.032C82.2173 263.722 81.6941 264.223 81.0663 264.286C80.2921 264.348 79.1829 264.411 78.0738 264.244C77.0694 264.098 76.3788 263.095 76.5671 262.008L77.9064 253.776H84.289V253.755Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3417 275.841C49.3641 275.694 51.9799 275.109 53.3192 274.566C53.3192 275.068 53.3192 275.569 53.2983 276.091C53.2774 276.655 52.8588 277.094 52.3566 277.094L24.7543 276.906C23.8754 276.906 23.3522 275.882 23.7499 275.067C27.3492 275.402 36.557 276.07 44.3417 275.841Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.728 275.109C23.7699 275.047 23.7908 274.963 23.8327 274.9C26.2811 271.495 32.4754 264.725 44.7593 261.778L50.6397 261.59C50.6397 261.59 53.2555 266.145 53.3183 274.566C51.979 275.109 49.3632 275.715 44.3408 275.841C36.5561 276.07 27.3483 275.402 23.728 275.109Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7276 252.689C51.6648 253.128 50.8487 259.793 50.5348 262.363C50.4511 262.969 50.0116 263.45 49.4466 263.513C48.4421 263.638 46.8308 263.743 45.4077 263.45C44.6335 263.304 44.0894 262.552 44.0894 261.695V251.247L51.7276 252.689Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4571 131.187C56.4571 131.187 42.2688 185.053 42.5199 252.856C42.5199 254.089 43.3988 255.155 44.6126 255.406C46.3913 255.782 49.0281 256.22 51.1836 256.158C52.3345 256.116 53.318 255.259 53.5064 254.131C55.4944 242.472 66.9204 176.8 73.4286 166.143C73.4286 166.143 77.7185 224.628 76.3374 254.967C76.2955 255.719 76.8606 256.367 77.6139 256.471C78.744 256.597 80.5855 256.701 82.8874 256.45C83.7663 256.367 84.4778 255.698 84.6034 254.821C86.0264 244.958 94.1878 186.244 93.8321 143.932C93.8111 141.55 87.5122 131.166 87.5122 131.166H56.4571V131.187Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.717 84.3196C104.568 73.7678 103.186 61.043 103.165 60.9176L102.098 61.043C102.119 61.1684 103.479 73.6634 99.7124 83.9644L100.717 84.3196Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77604 88.7284C-1.40482 71.4275 3.15722 42.9062 3.15722 42.9062L9.39339 49.3418C9.39339 49.3418 10.4397 72.6186 14.8762 82.2719C11.9674 82.6063 6.31714 83.9226 1.77604 88.7284Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8764 82.272C15.7135 84.0898 16.6761 85.4271 17.7643 86.033C21.7613 88.227 29.5251 75.711 35.3217 64.8458C39.4861 57.0521 42.6251 50.115 42.6251 50.115C46.7895 45.4137 57.1063 44.766 66.6907 45.3719C76.6727 45.9987 85.8595 47.9629 86.5292 48.1091C86.5501 48.1091 86.571 48.1091 86.571 48.1091C91.1749 48.7151 95.1509 49.2165 98.0388 49.5926C101.408 50.0105 104.484 51.6821 106.723 54.2522C115.533 64.4279 134.87 92.3223 112.101 120.426C109.193 118.817 105.049 116.226 102.245 113.217C104.756 106.134 104.966 97.0654 99.692 85.9495C99.5037 86.827 99.2944 87.7046 99.0223 88.5613C91.7399 111.566 91.3632 130.727 91.3841 135.136C91.3841 135.742 91.0284 136.285 90.4634 136.494C80.8999 140.317 62.4636 138.04 56.2693 137.121C55.1393 136.953 54.365 135.888 54.5324 134.759C56.3739 121.408 51.3515 102.832 46.1826 88.2688C15.9227 118.211 5.12463 106.907 1.77637 88.7493C6.31744 83.9227 11.9677 82.6063 14.8764 82.272Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3358 132.503C87.9726 131.04 98.1429 124.709 102.245 113.196C105.049 116.184 109.192 118.775 112.101 120.405C107.748 125.775 101.868 131.145 94.0622 136.41C93.7902 142.407 89.1654 144.622 88.1191 146.565C87.0727 148.508 88.5585 148.069 87.8889 150.493C87.2192 152.938 80.2298 146.607 78.5556 145.165C76.8815 143.723 77.8859 139.732 77.8859 139.732C77.8859 139.732 77.7813 138.897 77.3209 137.246C76.9443 135.574 85.3149 132.524 85.3358 132.503Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5483 30.7874L83.3898 49.6134C83.3898 49.6134 72.7801 52.8103 65.0791 47.3777L70.4991 30.265L81.5483 30.7874Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.973 87.6211C45.9939 87.6211 45.9939 87.6211 46.0149 87.6211C46.2032 87.6002 46.3287 87.433 46.3078 87.245C46.2869 87.0987 44.4872 72.5559 45.4708 68.377C45.5126 68.1889 45.408 68.0218 45.2197 67.98C45.0313 67.9382 44.8639 68.0426 44.822 68.2307C43.8176 72.535 45.5754 86.7226 45.6382 87.3285C45.6591 87.5166 45.8056 87.6211 45.973 87.6211Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76483 23.0353C3.78576 22.6383 3.9741 22.2831 4.288 22.0532C4.6019 21.8234 4.99949 21.7189 5.37617 21.8234L14.8978 23.9755C15.2744 24.0591 15.5047 24.4143 15.4628 24.7904L12.7005 49.4881C12.6795 49.5926 12.6377 49.6971 12.554 49.7597C12.4703 49.8224 12.3657 49.8642 12.261 49.8433L3.9532 48.8404C3.26262 48.7568 2.76039 48.1718 2.80224 47.4822L3.76483 23.0353Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44413 24.456C6.46505 24.2262 6.56967 24.0382 6.73708 23.8919C6.92542 23.7665 7.13469 23.7247 7.36488 23.7665L13.622 25.3336C13.9777 25.4172 14.2289 25.7724 14.187 26.1485L11.8014 47.1896C11.7805 47.2941 11.7386 47.3986 11.634 47.4613C11.5503 47.524 11.4247 47.5449 11.3201 47.5449L5.54427 46.521C5.335 46.4792 5.20947 46.312 5.20947 46.1031L6.44413 24.456Z",
    fill: "#91B3FA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0437 23.892C10.0228 23.9756 10.1274 24.0592 10.2739 24.0801L12.3666 24.5189C12.513 24.5398 12.6386 24.5189 12.6595 24.4353L12.6805 24.3726C12.7014 24.289 12.5967 24.2054 12.4502 24.1845L10.3576 23.7457C10.2111 23.7248 10.0856 23.7457 10.0646 23.8293L10.0437 23.892Z",
    fill: "url(#paint15_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.457597 29.3037C2.00615 28.7395 4.99863 23.5367 5.58457 25.2501C6.17051 26.9635 5.33346 29.3037 5.58457 30.035C5.83569 30.7663 7.48888 34.799 6.73553 36.6587C6.19144 37.9959 5.31253 42.1331 4.85215 44.327C4.70566 45.0583 4.05696 45.5807 3.30361 45.5807C2.55026 45.5807 1.92249 45.0583 1.75508 44.327C1.71322 44.0554 -1.07003 29.8888 0.457597 29.3037Z",
    fill: "url(#paint16_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6676 12.6925C61.6676 12.6925 58.8425 25.6891 59.7424 32.0202C60.6422 38.3722 60.0981 42.6974 67.6108 42.5302C75.1235 42.3422 80.5226 37.5155 82.5943 30.6202C82.5943 30.6202 85.8798 19.9639 83.9127 16.2446C81.9874 12.5254 61.6676 12.6925 61.6676 12.6925Z",
    fill: "url(#paint17_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2253 26.6084L78.7858 26.5039C78.2208 26.3785 77.8651 25.7935 78.0325 25.2293C78.6603 23.0563 79.7694 18.1251 76.9652 17.5818C73.3659 16.8714 59.659 16.8088 55.8922 12.7134C52.2719 8.76427 53.5275 2.49583 56.8548 0.134722C57.085 -0.0324362 57.378 0.00935847 57.5454 0.218306L57.9639 0.740675C58.2569 1.09589 58.8219 0.907848 58.8638 0.469058C58.9056 0.0302685 59.4288 -0.157784 59.7218 0.155637C60.8727 1.38843 63.6769 3.16448 70.2269 3.0809C79.5183 2.95553 86.1729 5.40022 87.5541 11.5642C87.6378 11.9612 88.0982 12.0865 88.3912 11.8149C88.9771 11.2716 90.0025 10.8746 91.6557 11.794C94.5226 13.382 94.5854 18.94 90.0653 24.4144C89.856 24.6652 89.9397 25.0831 90.2536 25.2084C91.3627 25.6472 93.1205 26.88 89.7304 29.6381C86.2357 32.5007 83.2851 32.8977 82.1132 32.9395C81.8202 32.9395 81.59 32.7096 81.59 32.4171L81.7156 26.7338C81.7156 26.4203 81.4226 26.1696 81.1087 26.2323L79.2253 26.6084Z",
    fill: "url(#paint18_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2246 27.7994C79.2246 27.7994 79.685 19.7759 83.5564 21.2385C87.4068 22.7011 83.4727 30.1396 80.7731 30.9754L79.2246 27.7994Z",
    fill: "url(#paint19_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.0378,
    y1: 30.404,
    x2: 21.2012,
    y2: 44.7656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 105.325,
    y1: 260.88,
    x2: 30.646,
    y2: 319.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 98.4132,
    y1: 275.325,
    x2: 32.2753,
    y2: 253.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 78.8859,
    y1: 244.838,
    x2: 82.7997,
    y2: 279.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 19.8713,
    y1: 260.88,
    x2: 94.5504,
    y2: 319.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 51.1357,
    y1: 272.943,
    x2: -10.4582,
    y2: 252.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 46.9087,
    y1: 248.496,
    x2: 50.8226,
    y2: 282.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 68.1795,
    y1: 139.66,
    x2: 68.1795,
    y2: 299.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 100.909,
    y1: 70.9549,
    x2: 87.181,
    y2: 31.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 9.24942,
    y1: 91.2371,
    x2: 32.2754,
    y2: 234.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 128.651,
    y1: 22.8706,
    x2: 36.4308,
    y2: 128.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 112.122,
    y1: 132.11,
    x2: 77.3649,
    y2: 132.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 74.8713,
    y1: 78.3374,
    x2: 73.3859,
    y2: 9.53044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 277.287,
    y1: -82.1471,
    x2: 55.4962,
    y2: 71.4022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2807,
    stopColor: "#FF8882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: -0.63315,
    y1: 22.4406,
    x2: 34.965,
    y2: 72.7422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 10.8305,
    y1: 23.5324,
    x2: 11.2154,
    y2: 26.0474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D55D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#1C2873"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: -1.44185,
    y1: 27.6556,
    x2: 19.5957,
    y2: 57.3823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: -437.696,
    y1: -1539.51,
    x2: -451.341,
    y2: -1581.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 80.0588,
    y1: 1.2463,
    x2: 59.4605,
    y2: 42.4476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: -428.246,
    y1: -1542.57,
    x2: -441.89,
    y2: -1584.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateServiceTwo);
export default __webpack_public_path__ + "static/media/RateServiceTwo.effe8ccad1157283321648284c607827.svg";
export { ForwardRef as ReactComponent };